export default __webpack_public_path__ + "static/media/offCall.55f4e153.svg";